import React, {useMemo} from 'react';
import Button from "@/components/UI/Button/Button";
import {useLocale} from "next-intl";

const createExternalLink = (settings) => {
    const Wrapper = settings.component ?? Button
    const baseUrl = settings.baseUrl

    return ({children, href, ...props}) => {
        const l = useLocale()
        const pathSegments = useMemo(() => {
            const segments = [baseUrl]

            if (settings.locale) segments.push(l)

            segments.push(href)

            return segments.join('/')
        }, [href])
        return <Wrapper {...props} href={pathSegments}>{children}</Wrapper>
    };
};

export default createExternalLink;